namespace Matrix.Exceptions {
    export interface ExceptionReviewRow {
        ExceptionSource?: string;
        ExceptionContext?: string;
        ExceptionKey?: string;
        IgnorePolicyCode?: string;
        Notes?: string;
        UserTags?: string;
        AssignedTo?: string;
        AssignedBy?: string;
        AssignedWhen?: string;
        ReviewedBy?: string;
        ReviewedWhen?: string;
        IgnoredBy?: string;
        IgnoredWhen?: string;
        IgnoredUntil?: string;
        RowId?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        Version?: number;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        CompletedBy?: string;
        CompletedWhen?: string;
        IgnorePolicyCodeDescription?: string;
        IgnorePolicyCodeRowId?: number;
    }

    export namespace ExceptionReviewRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'ExceptionSource';
        export const localTextPrefix = 'Exceptions.ExceptionReview';
        export const deletePermission = 'DataAdmin:Exception';
        export const insertPermission = 'DataAdmin:Exception';
        export const readPermission = 'Read:Exception';
        export const updatePermission = 'DataAdmin:Exception';

        export declare const enum Fields {
            ExceptionSource = "ExceptionSource",
            ExceptionContext = "ExceptionContext",
            ExceptionKey = "ExceptionKey",
            IgnorePolicyCode = "IgnorePolicyCode",
            Notes = "Notes",
            UserTags = "UserTags",
            AssignedTo = "AssignedTo",
            AssignedBy = "AssignedBy",
            AssignedWhen = "AssignedWhen",
            ReviewedBy = "ReviewedBy",
            ReviewedWhen = "ReviewedWhen",
            IgnoredBy = "IgnoredBy",
            IgnoredWhen = "IgnoredWhen",
            IgnoredUntil = "IgnoredUntil",
            RowId = "RowId",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            Version = "Version",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            CompletedBy = "CompletedBy",
            CompletedWhen = "CompletedWhen",
            IgnorePolicyCodeDescription = "IgnorePolicyCodeDescription",
            IgnorePolicyCodeRowId = "IgnorePolicyCodeRowId"
        }
    }
}
